import { cn } from '#src/styling/cn.ts';
import type { ComponentProps } from 'react';

export type TextareaProps = ComponentProps<'textarea'>;

export const Textarea = ({ className, ...props }: TextareaProps) => {
  return (
    <textarea
      className={cn(
        'w-full rounded-sm border border-gray-300 bg-transparent px-3 py-2 transition-colors placeholder:text-gray-400 hover:border-gray-400 focus-visible:border-violet-600 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
};
